<template>
    <div>
        <canvas></canvas>
        <div id="home">
            <figure>
                <img src="@/assets/svg/logo.svg"/>
            </figure>
            <h1>
                The Interactive Medical Visit<br> of <b>Mavenclad</b><sup>™</sup>
            </h1>
            <h2>
                Discover drugs through an immersive experience.
            </h2>
            <button @click="startExp" class="animated fadeIn">Start experience</button>
            <!--<button @click="gatest" class="animated fadeIn">Reponse 1</button>-->
            <!--<button @click="gatest2" class="animated fadeIn">Reponse 2</button>-->

        </div>
        <!--<FullScreenButton/>-->
    </div>
</template>

<script>
    import FullScreenButton from "@/components/FullScreenButton"
    import screenfull from 'screenfull'
    // @ is an alias to /src
    export default {
        name: 'home',
        mounted() {
            console.log("develop")
            let ua = window.navigator.userAgent;
            let msie = ua.indexOf("MSIE ");

            if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))  // If Internet Explorer, return version number
            {
                return false
            } else  // If another browser, return 0
            {
                (function () {

                    let canvas, ctx, circ, nodes, mouse, SENSITIVITY, SIBLINGS_LIMIT, DENSITY, NODES_QTY, ANCHOR_LENGTH,
                        MOUSE_RADIUS;

                    // how close next node must be to activate connection (in px)
                    // shorter distance == better connection (line width)
                    SENSITIVITY = 100;
                    // note that siblings limit is not 'accurate' as the node can actually have more connections than this value that's because the node accepts sibling nodes with no regard to their current connections this is acceptable because potential fix would not result in significant visual difference
                    // more siblings == bigger node
                    SIBLINGS_LIMIT = 10;
                    // default node margin
                    DENSITY = 50;
                    // total number of nodes used (incremented after creation)
                    NODES_QTY = 0;
                    // avoid nodes spreading
                    ANCHOR_LENGTH = 20;
                    // highlight radius
                    MOUSE_RADIUS = 200;

                    circ = 2 * Math.PI;
                    nodes = [];

                    canvas = document.querySelector('canvas');
                    resizeWindow();
                    mouse = {
                        x: canvas.width / 2,
                        y: canvas.height / 2
                    };
                    ctx = canvas.getContext('2d');
                    if (!ctx) {
                        alert("Ooops! Your browser does not support canvas :'(");
                    }

                    function Node(x, y) {
                        this.anchorX = x;
                        this.anchorY = y;
                        this.x = Math.random() * (x - (x - ANCHOR_LENGTH)) + (x - ANCHOR_LENGTH);
                        this.y = Math.random() * (y - (y - ANCHOR_LENGTH)) + (y - ANCHOR_LENGTH);
                        this.vx = Math.random() * 2 - 1;
                        this.vy = Math.random() * 2 - 1;
                        this.energy = Math.random() * 100;
                        this.radius = Math.random();
                        this.siblings = [];
                        this.brightness = 0;
                    }

                    Node.prototype.drawNode = function () {
                        let color = "rgba(255, 255, 255, " + this.brightness + ")";
                        ctx.beginPath();
                        ctx.arc(this.x, this.y, 2 * this.radius + 2 * this.siblings.length / SIBLINGS_LIMIT, 0, circ);
                        ctx.fillStyle = color;
                        ctx.fill();
                    };

                    Node.prototype.drawConnections = function () {
                        for (let i = 0; i < this.siblings.length; i++) {
                            let color = "rgba(255, 255, 255, " + this.brightness + ")";
                            ctx.beginPath();
                            ctx.moveTo(this.x, this.y);
                            ctx.lineTo(this.siblings[i].x, this.siblings[i].y);
                            ctx.lineWidth = 1 - calcDistance(this, this.siblings[i]) / SENSITIVITY;
                            ctx.strokeStyle = color;
                            ctx.stroke();
                        }
                    };

                    Node.prototype.moveNode = function () {
                        this.energy -= 2;
                        if (this.energy < 1) {
                            this.energy = Math.random() * 100;
                            if (this.x - this.anchorX < -ANCHOR_LENGTH) {
                                this.vx = Math.random() * 2;
                            } else if (this.x - this.anchorX > ANCHOR_LENGTH) {
                                this.vx = Math.random() * -2;
                            } else {
                                this.vx = Math.random() * 4 - 2;
                            }
                            if (this.y - this.anchorY < -ANCHOR_LENGTH) {
                                this.vy = Math.random() * 2;
                            } else if (this.y - this.anchorY > ANCHOR_LENGTH) {
                                this.vy = Math.random() * -2;
                            } else {
                                this.vy = Math.random() * 4 - 2;
                            }
                        }
                        this.x += this.vx * this.energy / 100;
                        this.y += this.vy * this.energy / 100;
                    };

                    function initNodes() {
                        ctx.clearRect(0, 0, canvas.width, canvas.height);
                        nodes = [];
                        for (let i = DENSITY; i < canvas.width; i += DENSITY) {
                            for (let j = DENSITY; j < canvas.height; j += DENSITY) {
                                nodes.push(new Node(i, j));
                                NODES_QTY++;
                            }
                        }
                    }

                    function calcDistance(node1, node2) {
                        return Math.sqrt(Math.pow(node1.x - node2.x, 2) + (Math.pow(node1.y - node2.y, 2)));
                    }

                    function findSiblings() {
                        let node1, node2, distance;
                        for (let i = 0; i < NODES_QTY; i++) {
                            node1 = nodes[i];
                            node1.siblings = [];
                            for (let j = 0; j < NODES_QTY; j++) {
                                node2 = nodes[j];
                                if (node1 !== node2) {
                                    distance = calcDistance(node1, node2);
                                    if (distance < SENSITIVITY) {
                                        if (node1.siblings.length < SIBLINGS_LIMIT) {
                                            node1.siblings.push(node2);
                                        } else {
                                            let node_sibling_distance = 0;
                                            let max_distance = 0;
                                            let s;
                                            for (let k = 0; k < SIBLINGS_LIMIT; k++) {
                                                node_sibling_distance = calcDistance(node1, node1.siblings[k]);
                                                if (node_sibling_distance > max_distance) {
                                                    max_distance = node_sibling_distance;
                                                    s = k;
                                                }
                                            }
                                            if (distance < max_distance) {
                                                node1.siblings.splice(s, 1);
                                                node1.siblings.push(node2);
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }

                    function redrawScene() {
                        resizeWindow();
                        ctx.clearRect(0, 0, canvas.width, canvas.height);
                        findSiblings();
                        let i, node, distance;
                        for (i = 0; i < NODES_QTY; i++) {
                            node = nodes[i];
                            distance = calcDistance({
                                x: mouse.x,
                                y: mouse.y
                            }, node);
                            if (distance < MOUSE_RADIUS) {
                                node.brightness = 1 - distance / MOUSE_RADIUS;
                            } else {
                                node.brightness = 0;
                            }
                        }
                        for (i = 0; i < NODES_QTY; i++) {
                            node = nodes[i];
                            if (node.brightness) {
                                node.drawNode();
                                node.drawConnections();
                            }
                            node.moveNode();
                        }
                        requestAnimationFrame(redrawScene);
                    }

                    function initHandlers() {
                        document.addEventListener('resize', resizeWindow, false);
                        canvas.addEventListener('mousemove', mousemoveHandler, false);
                    }

                    function resizeWindow() {
                        canvas.width = (window.innerWidth);
                        canvas.height = (window.innerHeight);
                    }

                    function mousemoveHandler(e) {
                        mouse.x = e.clientX;
                        mouse.y = e.clientY;
                    }

                    initHandlers();
                    initNodes();
                    redrawScene();

                })();
            }

        },
        data() {
            return {
                counter: 0
            }
        },
        components: {
            FullScreenButton
        },
        methods: {
            startExp() {
                this.$ga.event({
                    eventCategory: 'Start',
                    eventAction: 'starting',
                    eventValue: true
                })
                if (screenfull.enabled) {
                    screenfull.request();
                }
                this.$router.push('/personnalisez-votre-visite')
            }
            // gatest(){
            //     this.$ga.event({
            //         eventCategory : 'QuestionX',
            //         eventAction : 'AnswerTrue',
            //         eventValue : true
            //     })
            // },
            // gatest2(){
            //     this.$ga.event({
            //         eventCategory : 'QuestionX',
            //         eventAction : 'AnswerFalse',
            //         eventValue : true
            //     })
            // }
        }
    }
</script>

<style lang="scss" scoped>


    #loading-video {
        position: fixed;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-flow: column;
        background-color: #3e6cc6;
        background: linear-gradient(45deg, #3e6cc6, #2237a2);
        background-size: cover;
        background-repeat: no-repeat;

        img {
            width: 220px;
            height: auto;
            margin-bottom: 100px;
        }

        .spinner {
            &:after {
                background-color: #fff !important;
            }
        }
    }

    canvas {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        overflow: hidden;
        z-index: 2;
        opacity: 0.5;
    }

    #home {
        position: absolute;
        width: 100%;
        top: 27%;
        text-align: center;

        figure {
            margin: auto;
            width: 220px;
            height: auto;
        }

        h1 {
            font-size: 1.875rem;
            color: #fff;
            font-weight: normal;
            line-height: 1.5;
        }

        h2 {
            font-size: 1.5rem;
            font-family: 'Roboto Condensed', sans-serif;
            font-weight: normal;
            color: #fff;
        }

        button {
            border: 3px solid #fff;
            background-color: #fff;
            color: #2235a1;
            padding: 20px 30px;
            border-radius: 50px;
            font-size: 1.5rem;
            font-weight: bold;
            margin-top: 25px;
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
            transition: all 0.5s cubic-bezier(.25, .8, .25, 1);
            cursor: pointer;
            outline: none;
            z-index: 3;
            overflow: hidden;
            position: relative;
            animation-delay: 1s;

            &:hover {
                box-shadow: 6px 9px 10px 0px rgba(0, 0, 0, 0.2);
                padding-right: 50px;

                &:after {
                    right: 5%;
                }
            }

            &:after {
                content: '→';
                right: -10%;
                transition: 400ms;
                transition-timing-function: cubic-bezier(0.18, 0.89, 0.32, 1.28);
                position: absolute;
            }
        }
    }

    @media screen and (max-width: 1024px) {

        #home {
            top: 14%;

            h2 {
                font-size: 1.1rem;
            }

            h1 {
                font-size: 1.3rem;
            }

            button {
                font-size: 1.1rem;
            }
        }
    }

</style>